import React, { useState, useEffect } from "react";
import { useTable, useSortBy } from "react-table";
import DatePicker from "react-datepicker";
import { SelectInput } from '../../Global/SelectInput/SelectInput';

import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { SmallSpinner } from "../../dashboard/partials/SmallSpinner";
import { SalesDetalizationModal } from "./SalesDetalizationModal";
import { Pager } from "../Pager/Pager";
import { PREV_STATE, OUTER_CLICK, GET_USER_LEVEL } from "./../../../helpers";
import { EmptyData } from "../../Global/EmptyData/EmptyData";
import {
  GET_TRANSACTIONS,
  GET_PURCHASES,
  API_URL,
  GET_TRANSACTIONS_FILTERS,
  GET_TRANSACTIONS_EXCEL_FILE,
  CONTINENTS,
} from "./../../../constants";
import { ARRAY_EMPTY, GET_TOKEN, CURRENCY } from "./../../../helpers";
import "./SalesDetalization.css";
import returnIcon from "./../../../images/icons_return.svg";
import downloadGif from "./../../../images/download_gif.gif";
import downloadGifStable from "./../../../images/download_gif_stable.png";

export const SalesDetalization = (props) => {
  const [modalId, setModalId] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [salesModalActive, setSalesModalActive] = useState(false);
  const [filedDowloadInProgress, setFiledDowloadInProgress] = useState(false);
  const [salesDetalizationData, setSalesDetalizationData] = useState([]);
  const [fullTransactionData, setFullTransactionData] = useState({});
  const [transactionFilters, setTransactionFilters] = useState([]);
  const [reportTableSelection, setReportTableSelection] = useState(false);

  const [filterPayload, setFilterPayload] = useState({
    sales: undefined,
    types: undefined,
    regions: undefined,
    country: undefined,
    from: undefined,
    to: undefined,
    q: undefined,
  });
  const prevFilterPayload = PREV_STATE(filterPayload);

  /**
   * Pager Settings
   */

  const [maxPageCount, setMaxPageCount] = useState(1); //will set on response
  const [currentPage, setCurrentPage] = useState(1);

  const currentPageSetter = (e) => {
    setCurrentPage(parseInt(e.target.getAttribute("value")));
  };

  const currentPageSetterIncrease = () => {
    currentPage < maxPageCount && setCurrentPage(currentPage + 1);
  };

  const currentPageSetterDecrease = () => {
    currentPage > 1 && setCurrentPage(currentPage - 1);
  };

  const openTable = () => {
    if (reportTableSelection) {
      setReportTableSelection(false)

    } else {
      setReportTableSelection(true)
    }
  }
  const getExcelFile = () => {
    setFiledDowloadInProgress(true)

    setTimeout(() => {
      setFiledDowloadInProgress(false)
    }, 4000);
    // Redundant, think of way to globalize this
    const generateString = () => {
      let result = "/?";
      const querryString = {
        sales: filterPayload.sales,
        regions: filterPayload.regions,
        types: filterPayload.types,
        country: filterPayload.country,
        from:
          filterPayload.from &&
          filterPayload.from.getFullYear() +
          "-" +
          (filterPayload.from.getMonth() + 1) +
          "-" +
          filterPayload.from.getDate(),
        to:
          filterPayload.to &&
          filterPayload.to.getFullYear() +
          "-" +
          (filterPayload.to.getMonth() + 1) +
          "-" +
          filterPayload.to.getDate(),
        q: filterPayload.q,
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined) {
          return (result = result.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return result;
    };

    let filename = '';

    fetch(API_URL + GET_TRANSACTIONS_EXCEL_FILE + generateString(), {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
    // .then( res => {
    //   filename = res.headers.get('Content-Language')

    //   return res.blob()
    // } )
    // .then( response => {

    //   let saveData = (function () {
    //       let a = document.createElement("a");

    //       document.body.appendChild(a);
    //       a.style = "display: none";

    //       return function (data, fileName) {
    //           var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}),
    //               url = window.URL.createObjectURL(blob);
    //           a.href = url;
    //           a.download = fileName;
    //           a.click();
    //           window.URL.revokeObjectURL(url);
    //       };
    //   }());

    //   saveData(response, filename);
    // })
    // .finally(() => setFiledDowloadInProgress(false))
  }

  // Fetch Filters
  useEffect(() => {
    if (ARRAY_EMPTY(transactionFilters)) {
      let result = [];

      fetch(API_URL + GET_TRANSACTIONS_FILTERS, {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          //eslint-disable-next-line
          Object.entries(response).map(([fieldItem, fieldItemValue]) => {
            let temproraryObject = {
              filtertype: fieldItem,
              filterItems: fieldItemValue,
            };

            result.push(temproraryObject);
          });
        })
        .then(() => setTransactionFilters([...result]));
    }
    //eslint-disable-next-line
  }, [transactionFilters]);

  // GET TRANSACTIONS
  useEffect(() => {
    setDataLoaded(false);

    // If filters changed, setting to 1
    prevFilterPayload !== filterPayload && setCurrentPage(1);

    const generateString = () => {
      let result = "/?";
      const querryString = {
        offset: (currentPage - 1) * 25,
        limit: 25,
        sales: filterPayload.sales,
        regions: filterPayload.regions,
        types: filterPayload.types,
        country: filterPayload.country,
        from:
          filterPayload.from &&
          filterPayload.from.getFullYear() +
          "-" +
          (filterPayload.from.getMonth() + 1) +
          "-" +
          filterPayload.from.getDate(),
        to:
          filterPayload.to &&
          filterPayload.to.getFullYear() +
          "-" +
          (filterPayload.to.getMonth() + 1) +
          "-" +
          filterPayload.to.getDate(),
        q: filterPayload.q,
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined && fieldItemValue !== null) {
          return (result = result.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return result;
    };

    fetch(API_URL + (filterPayload.sales !== 'purchases' ? GET_TRANSACTIONS : GET_PURCHASES) + generateString(), {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setFullTransactionData(response);
      })
      // .then(() => setDataLoaded(true))
      .catch((err) => console.log(err))
      .finally(() => setDataLoaded(true))
    //eslint-disable-next-line
  }, [filterPayload, currentPage]);

  // After Filter update initiate new data fetch
  useEffect(() => {
    if (fullTransactionData.result) {
      setSalesDetalizationData([...fullTransactionData.result]);
      setMaxPageCount(fullTransactionData.pages);
    }
  }, [fullTransactionData]);

  // Effect for removing elements
  useEffect(() => {
    // adding here because elements will change on state change
    OUTER_CLICK(".SalesDetalization__settings");
  });

  const filterSelect = (e) => {
    const filterType = e.target.options[e.target.selectedIndex].getAttribute(
      "filtertype"
    );
    const selectedOptionValue = e.target.value;

    setFilterPayload({ ...filterPayload, [filterType]: selectedOptionValue });
  };

  const columnsTransactions = [
    {
      Header: "",
      accessor: "detected_region_img",
    },
    {
      Header: "Detected region",
      accessor: "detected_region",
    },
    {
      Header: "Transaction ID",
      accessor: "order_id",
    },
    {
      Header: "Date & time",
      accessor: "date_time",
    },
    {
      Header: "NET value",
      accessor: "value",
    },
    {
      Header: "VAT on sales",
      accessor: "vat_on_sales",
      Cell: (cell) => {
        const error = cell.data[cell.row.id].error_message

        // <div className={'flex-align-center ' + (error.length > 0 ? 'has-error' : '')}>

        return <div className={'flex-align-center ' + (error ? 'has-error' : '')}>
          {CURRENCY(cell.value, cell.row.original.currency_symbol)}

          {/* error_message: [{“messgage”: test, type:1}, {“message”: test, type: 2}] */}

          {error && (<>
            <span className="circle"></span>

            <div className='tooltip flex'>
              <span className="circle"></span>
              {error}

              {/* 
                error.map((item, i) => {
                  return (
                    <div className="tooltip_error_item" key={i + cell.row.id + cell.value}>                
                      <span className={`circle ${item.type === 2 ? 'warning' : '' }`></span>
                      {item.message}
                    </div>
                  )
                })
              */}
            </div>
          </>)}

        </div>
      },
    },
    {
      Header: "GROSS value",
      accessor: "gross_value",
    },
    {
      Header: "",
      accessor: "settings",
    },
  ];

  const columnsPurchases = [
    {
      Header: "",
      accessor: "detected_region_img",
    },
    {
      Header: "Seller region",
      accessor: "detected_region",
    },
    {
      Header: "Invoice Number",
      accessor: "invoice_number",
    },
    {
      Header: "Date",
      accessor: "date_time",
    },
    {
      Header: "Net value",
      accessor: "value",
    },
    {
      Header: "VAT on sales",
      accessor: "vat_on_sales",
      Cell: (cell) => {
        const error = cell.data[cell.row.id].error_message

        // <div className={'flex-align-center ' + (error.length > 0 ? 'has-error' : '')}>

        return <div className={'flex-align-center ' + (error ? 'has-error' : '')}>
          {CURRENCY(cell.value, cell.row.original.currency_symbol)}

          {/* error_message: [{“messgage”: test, type:1}, {“message”: test, type: 2}] */}

          {error && (<>
            <span className="circle"></span>

            <div className='tooltip flex'>
              <span className="circle"></span>
              {error}

              {/* 
                error.map((item, i) => {
                  return (
                    <div className="tooltip_error_item" key={i + cell.row.id + cell.value}>                
                      <span className={`circle ${item.type === 2 ? 'warning' : '' }`></span>
                      {item.message}
                    </div>
                  )
                })
              */}
            </div>
          </>)}

        </div>
      },
    },
    {
      Header: "GROSS value",
      accessor: "gross_value",
    },
  ];

  const toggleModal = (salesId) => {
    setModalId(salesId);
    return setSalesModalActive(!salesModalActive);
  };

  const listTabledetails = (itemValue) => {
    return itemValue.map((element, i) => {
      return (
        <tr
          className="SalesDetalization__tableDetails__item"
          role="row"
          key={i}
        >
          <td className="empty-cell"></td>
          <td className="empty-cell"></td>
          <td className="SalesDetalization__tableDetails__item--content name">
            {element.name}
          </td>
          <td className="SalesDetalization__tableDetails__item--content">
            {element.net_value}
          </td>
          <td className="SalesDetalization__tableDetails__item--content">
            {element.vat_on_sales}
          </td>
          <td className="SalesDetalization__tableDetails__item--content">
            {element.gross}
          </td>
          <td className="empty-cell"></td>
        </tr>
      );
    });
  };

  const listTableReturn = (itemValue) => {
    return (
      <tr
        className="SalesDetalization__refund refund-info"
        role="row"
        key={itemValue.order_id}
      >
        <td>
          <div className='SalesDetalization__refund_refund-cell'>
            <img src={returnIcon} alt='return' />
            Refund
          </div>
        </td>
        <td name="order_id" onClick={() => toggleModal(itemValue.order_id)}>
          {itemValue.order_id}
        </td>
        <td>{itemValue.date_time}</td>
        <td className="empty-cell"></td>
        <td className="empty-cell"></td>
        <td>
          {itemValue.gross_value && CURRENCY(itemValue.gross_value, itemValue.currency_symbol)}
        </td>
        <td className="empty-cell"></td>
      </tr>
    );
  };

  const Table = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable(
      {
        columns,
        data,
      },
      useSortBy
    );
    
    const reportAll = (type) => {
      console.log("All report");
      setFiledDowloadInProgress(true)

      setTimeout(() => {
        setFiledDowloadInProgress(false)
      }, 4000);
      // Redundant, think of way to globalize this
      const generateString = () => {
        let result = "/?";
        const querryString = {
          sales: filterPayload.sales,
          regions: filterPayload.regions,
          types: filterPayload.types,
          country: filterPayload.country,
          from:
            filterPayload.from &&
            filterPayload.from.getFullYear() +
            "-" +
            (filterPayload.from.getMonth() + 1) +
            "-" +
            filterPayload.from.getDate(),
          to:
            filterPayload.to &&
            filterPayload.to.getFullYear() +
            "-" +
            (filterPayload.to.getMonth() + 1) +
            "-" +
            filterPayload.to.getDate(),
          q: filterPayload.q,
        };
  
        //eslint-disable-next-line
        Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
          if (fieldItemValue !== undefined) {
            return (result = result.concat(`${fieldItem}=${fieldItemValue}&`));
          }
        });
  
        return result;
      };
  
      let filename = '';
      fetch(API_URL + GET_TRANSACTIONS_EXCEL_FILE + '/' + type + generateString(), {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })

      setReportTableSelection(false)

    };

    return (
      <>
        <table {...getTableProps()} className="default-table relative">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  return headerGroup.headers.length - 1 === index ? (
                    <th className="SalesDetalization__excel" key={"excel"}>

                      {(reportTableSelection) ?    <table class="table-selector">
                        <tr onClick={() => reportAll("all")}>api / file report</tr>
                        <tr onClick={() => reportAll("amazon")}>Amazon only report</tr>

                      </table>
                      
                    : ""}
                   


                      {(filedDowloadInProgress && GET_USER_LEVEL() >= 4) && <img src={downloadGif} className="SalesDetalization__excel-loading" alt='return' />}
                      {(!filedDowloadInProgress && GET_USER_LEVEL() >= 4) && <img src={downloadGifStable} className="SalesDetalization__excel-loading" alt='return' onClick={() => openTable()} />}


                      {/* {!filedDowloadInProgress && <div className="SalesDetalization__excel-icon icon" onClick={() => getExcelFile()}/>} */}
                    </th>
                  ) : (
                    <React.Fragment key={column.id}>
                      {column.Header !== "" && (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                        >
                          {column.render("Header")}

                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " 🔽"
                                : " 🔼"
                              : ""}
                          </span>
                        </th>
                      )}
                    </React.Fragment>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              let flagURL = '';

              return [
                <tr
                  {...row.getRowProps()}
                  key={`${i}_${row.id}`}
                  className={
                    row.original["refund_info"] ? " SalesDetalization__refund" : ""
                  }
                >
                  {row.cells.map((cell, index) => {
                    if (
                      cell.column.id === "value" ||
                      cell.column.id === "gross_value"
                    ) {
                      return (
                        <td
                          {...cell.getCellProps()}
                          key={cell.column.id + row.id}
                        >
                          <div className="flex-align-center">
                            {cell.value &&
                              CURRENCY(cell.value, cell.row.original.currency_symbol)
                            }
                          </div>
                        </td>
                      );
                    } else if (cell.column.id === "vat_on_sales") {

                      return <td {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>

                    } else if (cell.column.id === "detected_region") {
                      return (
                        <td {...cell.getCellProps()}>
                          <div className="flex-align-center">
                            {flagURL !== null && (
                              <img
                                src={flagURL}
                                className="flag-icon-img"
                                alt={cell.value}
                              />
                            )}

                            {cell.value !== null ? cell.value : "Undetected"}

                            {salesDetalizationData[i]
                              .detected_region_changes && (
                                <span className="move-right block icon_rotate-left"></span>
                              )}
                          </div>
                        </td>
                      );

                    } else if (cell.column.id === "detected_region_img") {
                      flagURL = cell.value
                      return;
                    } else {
                      return (
                        <td
                          {...cell.getCellProps()}
                          key={index}
                          name={cell.column.id}
                          onClick={() => {
                            return cell.column.id === "order_id" || cell.column.id === "invoice_number"
                              ? toggleModal(row.original.id)
                              : undefined;
                          }}
                        >
                          {/* if last cell - render options cell */}
                          {row.cells.length - 1 === index ? (
                            <div className="table__settings--wrapper">
                              <button
                                type="button"
                                className="table__open-settings icon"
                                onClick={tableTooltip}
                              />

                              <ul className="table__settings">
                                <li>
                                  {/*eslint-disable-next-line*/}
                                  <a href="#">Edit</a>
                                </li>
                                <li>
                                  {/*eslint-disable-next-line*/}
                                  <a href="#">Remove</a>
                                </li>
                              </ul>
                            </div>
                          ) : cell.column.id === "order_id" || cell.column.id === "invoice_number" ? (
                            <div className="apikey relative">
                              {salesModalActive &&
                                row.original.id === modalId && (
                                  <SalesDetalizationModal
                                    rowid={row.original.id}
                                    rowLevel={row.id > 17 ? true : false}
                                    apiid={row.original.order_id}
                                    toggleModal={toggleModal}
                                    isPurchases={filterPayload.sales === 'purchases'}
                                  />
                                )}
                              {cell.render("Cell")}
                            </div>
                          ) : (
                            cell.render("Cell")
                          )}
                        </td>
                      );
                    }
                  })}
                </tr>,

                row.original["table_details"] &&
                  row.original["table_details"].length > 0
                  ? listTabledetails(row.original["table_details"])
                  : null,

                row.original["refund_info"] &&
                listTableReturn(row.original["refund_info"]),
              ];
            })}
          </tbody>
        </table>
        <br />
      </>
    );
  };

  const tableTooltip = (event) => {
    let currentTooltip = event.target.parentNode.childNodes[1];
    currentTooltip.classList.add("active");
  };

  return (
    <>
      <div className="Dashboard__content__top-row">
        <h2>Sales detalization</h2>

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            {transactionFilters.length &&
              //eslint-disable-next-line
              transactionFilters.map((item) => {
                if (item.filtertype !== "country") {
                  return (
                    <select
                      className={"filter " + item.filtertype + " Values-selector"}
                      onChange={(e) => filterSelect(e)}
                      key={item.filtertype}
                    >
                      {Object.entries(item.filterItems).map(
                        ([fieldItem, fieldItemValue]) => {
                          return (
                            <option
                              filtertype={item.filtertype}
                              value={fieldItem}
                              key={fieldItem}
                            >
                              {fieldItemValue}
                            </option>
                          );
                        }
                      )}
                    </select>
                  );
                }
              })}
          </li>
        </ul>
      </div>

      <div className="SalesDetalization__table-wrapper">
        <div className="SalesDetalization__table-filters">
          <div className="input-wrapper">
            {(transactionFilters.length > 0 &&
              //eslint-disable-next-line
              transactionFilters.map((item) => {
                if (item.filtertype === "country") {
                  return (
                    <select
                      className="SalesDetalization__search-by-country default-input"
                      onChange={(e) => filterSelect(e)}
                      key={item.filtertype}
                    >
                      <option
                        filtertype='country'
                        value='all'
                      >
                        All
                      </option>

                      <option
                        filtertype='country'
                        value='undetected'
                      >
                        Undetected
                      </option>

                      {/* list rest of the countries */}
                      {Object.entries(item.filterItems).map(
                        ([item, continentValue]) => {
                          return (
                            <optgroup label={CONTINENTS[item]} key={item}>
                              {continentValue.map((country) => (
                                <option
                                  filtertype='country'
                                  value={country.id}
                                  key={country.id}
                                >
                                  {country.name}
                                </option>
                              ))}
                            </optgroup>
                          );
                        }
                      )}

                    </select>
                  );
                }
              }))}
          </div>

          <div className="input-wrapper datefrom">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["from"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["from"]: newDate,
                });
              }}
              name="from"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-datefrom default-input"
              selectsEnd
            />
          </div>

          <div className="input-wrapper dateto">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["to"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["to"]: newDate,
                });
              }}
              name="to"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-dateto default-input"
              selectsEnd
            />
          </div>

          <div className="input-wrapper search">
            <input
              type="text"
              placeholder="Search by transaction ID"
              name="q"
              className="SalesDetalization__search-by-orderid default-input"
              value={(filterPayload["q"] && filterPayload["q"]) || ""}
              onChange={(e) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["q"]: e.target.value,
                });
              }}
            />
          </div>
        </div>

        {dataLoaded
          ? salesDetalizationData.length > 0
            ? <>
              <Table columns={filterPayload.sales !== 'purchases' ? columnsTransactions : columnsPurchases} data={salesDetalizationData} />

              {maxPageCount > 1 && (
                <div className="SalesDetalization__table-bottom flex-space-between">

                  <Pager
                    currentPage={currentPage}
                    maxPageCount={maxPageCount}
                    currentPageSetter={currentPageSetter}
                    currentPageSetterIncrease={currentPageSetterIncrease}
                    currentPageSetterDecrease={currentPageSetterDecrease}
                  />

                  <div className="SalesDetalization__count">
                    Total {fullTransactionData.count && fullTransactionData.count}
                  </div>
                </div>
              )}
            </>
            : <EmptyData title='You don’t have any sales detalization data' type='search' />

          : <LoadingSpinner />
        }
      </div>
    </>
  );
};
